import { ColumnType } from 'antd/es/table';
import { SupportUpload, UploadAssets } from '@dynamika-shared/types/subjects';

export type Props = {
  clinicalTrialId?: string;
  patientId?: string;
  visitId?: string | null;

  uploads: SupportUpload[];
  loading?: boolean;
  error?: Error;
};

export enum UploadDetailKind {
  EXEC = 'exec',
  ASSETS = 'assets',
  SUBHEADER_EXEC = 'subheader-exec',
  SUBHEADER_ASSETS = 'subheader-assets',
}
export type UploadRowGroup = {
  type: 'group';
  key: string;
  processLabel: string;
  user: string;
  userEmail?: string;
  uploadDate: string;
  preprocessingStatus?: string;
  uploadStatus?: string;
  actions?: React.ReactNode;
  uploadId: string;
};

export type UploadRowDetail = {
  type: 'detail';
  key: string;
  groupKey: string;
  detailKind: UploadDetailKind;
  execLabel?: string;
  startDate?: string;
  endDate?: string;
  detailUploadStatus?: string;
  assetLabel?: string;
  dicomSeriesUid?: UploadAssets['dicom'];
  dicomAcquisitionDate?: string;
  requestData?: unknown;
  responseData?: unknown;
  content?: React.ReactNode;
};

export type UploadRow = UploadRowGroup | UploadRowDetail;

export type UploadsTableConfigOptions = {
  iconColWidth?: number;
  detailIconIndentPx?: number;
  detailContentIndentClass?: string;

  headerBgClass?: string;
  rowBgClass?: string;
  headerBgInline?: string;
  rowBgInline?: string;
  headerTextClass?: string;

  dataFontSizePx?: number;
  dataLineHeightPx?: number;

  actionIconSizeClass?: string;
  dateTextClass?: string;
  timeTextClass?: string;
  onDeleteGroupClick?: (row: UploadRow) => void;
  onViewExecutionRequest?: (row: UploadRowDetail) => void;
  onViewExecutionResponse?: (row: UploadRowDetail) => void;
};

export type HeaderAttrs = React.HTMLAttributes<HTMLElement>;

export type OnHeaderCell = NonNullable<
  NonNullable<ColumnType<UploadRow>['onHeaderCell']>
>;
